// extracted by mini-css-extract-plugin
module.exports = {"top":"Card_top__h66i2","wrapper":"Card_wrapper__lwUZa","addPadding":"Card_addPadding__2tq4y"};